import React from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import {
  // Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "components/ui";
import {
  AddTagsAction,
  UpdateTagsAction,
} from "store/middlewares/dataManagement/tags";
import { SubmitLoaderButton } from "components/atoms";
import { useState } from "react";

function ModalEditTags({ row }) {
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);

  //--------------------- image change function ------------------------------

  const handleSubmit = (values) => {
    let tempObj = { ...values, title: values.title.trim() ,onSuccess: () => formik.setSubmitting(false),
    onError: () => {
      setFormError(true);
      formik.setSubmitting(false);
    },};

    if (row) {
      tempObj = {
        ...tempObj,
        id: row?.id,
      };
      dispatch(UpdateTagsAction(tempObj));
    } else {
      dispatch(AddTagsAction(tempObj));
    }
  };

  const formik = useFormik({
    initialValues: {
      title: row?.title ? row?.title : "",
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required("Title is required")
        .min(3, "Minimum 3 characters required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid gap-5 lg:gap-7.5 mx-auto">
        <Card className="min-w-full">
          <CardHeader>
            <CardTitle>Tags</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-5">
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32">Title</Label>
              <Input
                error={formik.errors.title && formik.touched.title}
                errorMsg={formik.errors.title}
                value={formik.values.title}
                type="text"
                name="title"
                maxLength={50}
                isSpace={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter title"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex justify-center">
              {/* <Button type={"submit"}>{row ? "Update" : "Add"}</Button> */}
              <SubmitLoaderButton
                 btnText={row ? "Update" : "Add"}
                isDisable={formik.isSubmitting && !formError}      
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}

export default ModalEditTags;
